import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
import PaywallModal from './PaywallModal';

const PUBLIC_ROUTES = [
    '/pricing',
    '/signup',
    '/login',
    '/about',
    '/ai-front-desk',
    '/visit-transcriptions',
    '/organization',
    '/accept-invite',
    '/vet-signup',
    '/contact',
    '/search',
    '/docs',
    '/solutions',
    '/create-practice',
];

const PaywallEnforcer: React.FC = () => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();
    const [showPaywall, setShowPaywall] = useState(false);

    useEffect(() => {
        const checkAccess = async () => {
            const isPublicRoute = location.pathname === '/' ||
                PUBLIC_ROUTES.some(route => location.pathname.startsWith(route));

            if (isPublicRoute || !isAuthenticated || !user?.practice_id) {
                setShowPaywall(false);
                return;
            }

            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/v1/practices/${user.practice_id}`,
                    { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } }
                );

                if (!response.ok) {
                    setShowPaywall(true);
                    return;
                }

                const practice = await response.json();
                setShowPaywall(!practice.bypass_paywall);
            } catch {
                setShowPaywall(true);
            }
        };

        checkAccess();
    }, [isAuthenticated, user?.practice_id, location.pathname]);

    return <PaywallModal isOpen={showPaywall} />;
};

export default PaywallEnforcer;
